import React from "react";
import App from "App";
import ReactDOM from "react-dom/client";
import reportWebVitals from "reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import "index.css";

// styles
import "assets/css/bootstrap.min.css";
import "assets/css/now-ui-kit.css";
import "assets/scss/now-ui-dashboard.scss";
import "assets/css/icons.css";

// import "assets/scss/now-ui-kit.min.css";
// import "assets/scss/now-ui-kit.css.map";
// import "assets/demo/demo.css";
// import "assets/demo/react-demo.css";
// import "assets/demo/nucleo-icons-page-styles.css";
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
